export default __webpack_public_path__ + "static/media/diversify.2cd4ce97.gif";